import { useMemo } from 'react';

import dateFormat from 'dateformat';

import DefaultSpinner from '@components/Loader/Loader';
import {
  BootstrapTable,
  BootstrapVerticalColumnTable,
} from '@components/Table/Table';

const renderLastCDRCell = ({ value, isLoading }) => {
  if (isLoading) {
    return <DefaultSpinner />;
  }
  if (!value) {
    return null;
  }
  const date = new Date(value);
  return dateFormat(date, 'defaultDateTime');
};

export const StatisticsTable = ({ data, isLoading }) => {
  const columns = useMemo(
    () => [
      {
        Header: 'Last CDR',
        accessor: 'start_time',
        className: 'col-md-2',
        Cell: ({ value }) => renderLastCDRCell({ value, isLoading }),
      },
    ],
    [isLoading]
  );
  return (
    <BootstrapVerticalColumnTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, bordered: true })}
      tableHeader="General"
    />
  );
};

export const CallStatisticsTable = ({ data, title }) => {
  const columns = useMemo(
    () => [
      {
        id: 'scope',
        Header: '',
        accessor: 'scope',
        className: 'col-md-1',
      },
      {
        Header: 'Unsuccessful calls',
        accessor: 'unsuccessful_calls',
        className: 'col-md-2 text-center',
      },
      {
        Header: 'Successful calls',
        accessor: 'successful_calls',
        className: 'col-md-2 text-center',
      },
      {
        Header: 'Minutes',
        accessor: 'minutes',
        className: 'col-md-2 text-center',
      },
    ],
    []
  );
  return Object.keys(data).length > 0 ? (
    <BootstrapTable
      columns={columns}
      data={data}
      tableProps={() => ({ responsive: true, bordered: true })}
      tableHeader={title}
    />
  ) : null;
};
